import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import Loader from "../../Loader/Loader";
import moment from "moment";
import { commonService } from "../../../utils/commonService";
import { dataTable } from "../../../utils/dataTable";

const OnDemandRateshopRequestStatusModal = ({ showModal, closeModal, propertyId, startdate, enddate }) => {
    const [loading, setLoading] = useState(false);
    const [requestList, setRequestList] = useState([]);

    const getRequestList = async () => {
        setLoading(true);
        let response = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Notification +
                    API_URL.THIRD_PARTY_API_REQUEST.GETONDEMANDLIST,
                body: {
                    propertyid: propertyId,
                    startrequestfordate: startdate,
                    endrequestfordate: enddate
                },
            },
            false
        );

        let res = apiResponse(false, response);
        if (res?.isValidate) {
            setRequestList(res?.data?.data || []);
        }
        if (!res?.isValidate) {
            setRequestList([]);
        }
        setLoading(false);

        dataTable("tblOnDemandRequestStatus");
    };

    useEffect(() => {
        if (propertyId) {
            getRequestList();
        }
    }, [propertyId]);

    return (
        <Modal
            show={showModal}
            onHide={closeModal}
            fullscreen
            centered
            className="AddPropertySetupModalMain"
        >
            <Modal.Header closeButton>
                <Modal.Title>Request Status of {commonService.getDateInFormat(startdate)} to {commonService.getDateInFormat(enddate)} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <Loader />
                ) : (
                    <div className="table__container">
                        <div className="stripped__table">
                            <Table responsive id="tblOnDemandRequestStatus">
                                <thead>
                                    <tr>
                                        <th className="width100">Request ID</th>
                                        <th className="width100">Type</th>
                                        <th>Title</th>
                                        <th className="width100">Status</th>
                                        <th className="width100">Created On</th>
                                        <th className="width100">Change On</th>
                                        <th className="width50">Debit</th>
                                        <th className="width50">Credit</th>
                                        <th className="width50">Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {requestList?.length > 0 ? (
                                        requestList.map((row, index) => (
                                            <tr
                                                key={index}
                                                className={
                                                    index % 2 === 0
                                                        ? "table-even"
                                                        : "table-odd"
                                                }
                                            >
                                                <td>{row?.requestid || ""}</td>
                                                <td>{row?.requesttype || ""}</td>
                                                <td>{row?.requesttitle || ""}</td>
                                                <td>{row?.requeststatus || ""}</td>
                                                <td>
                                                    {commonService.getConvertDateInTimeZone(row?.createdon, "", "MM/DD/yyyy HH:mm")}
                                                </td>
                                                <td>
                                                    {commonService.getConvertDateInTimeZone(row?.statuschangeon, "", "MM/DD/yyyy HH:mm")}
                                                </td>
                                                <td>{row?.debit || ""}</td>
                                                <td>{row?.credit || ""}</td>
                                                <td>{row?.newbalance || ""}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={9} className="text-center">
                                                No records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button id={commonService.generateGlobalClickTrackerID("OnDemandRateshopRequestStatusModal", "close", "")}
                    className="default-btn secondary-btn"
                    onClick={closeModal}
                >
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default OnDemandRateshopRequestStatusModal;
